export default __webpack_public_path__ + "static/media/bandMember-Nick.c2001c89.jpg";